t = require('app/scripts/views/internal/teacup-with-helpers')('card_detail_add_button')

module.exports = t.renderable ({ klass }) ->
  classes =
    'card-detail-item-add-button': true
  classes[klass] = true
  t.a { class: t.classify(classes) }, ->
    t.icon 'add'
